// CAPABILITY: Scrollable chat message list with auto-stick-to-bottom.
import React, { useEffect, useRef } from "react";
import ChatMessage from "./ChatMessage";

export default function ChatMessageList({ messages, viewerId, accentColor, accentText }) {
  const endRef = useRef(null);
  const containerRef = useRef(null);
  const stickRef = useRef(true);

  const onScroll = () => {
    const el = containerRef.current;
    if (!el) return;
    stickRef.current = el.scrollHeight - el.scrollTop - el.clientHeight < 80;
  };

  useEffect(() => {
    if (stickRef.current && endRef.current) {
      endRef.current.scrollIntoView({ block: "end" });
    }
  }, [messages]);

  if (!messages.length) {
    return (
      <div className="flex flex-1 flex-col items-center justify-center gap-2 bg-slate-50/60 px-6 text-center">
        <div className="flex h-12 w-12 items-center justify-center rounded-full bg-slate-200/70 text-2xl">💬</div>
        <p className="text-sm font-medium text-slate-500">No messages yet</p>
        <p className="text-xs text-slate-400">Be the first to say hello 👋</p>
      </div>
    );
  }

  return (
    <div
      ref={containerRef}
      onScroll={onScroll}
      className="flex-1 space-y-1 overflow-y-auto bg-slate-50/60 py-3"
    >
      {messages.map((m) => (
        <ChatMessage
          key={m.id}
          message={m}
          isOwn={m.viewer_id === viewerId}
          accentColor={accentColor}
          accentText={accentText}
        />
      ))}
      <div ref={endRef} />
    </div>
  );
}
